export default __webpack_public_path__ + "assets/images/cdeeb727b63dfd31c5bedcdc3e2fbf86.png";